import {ChangeDetectionStrategy, Component, Input} from '@angular/core';


@Component({
    selector: 'app-currency',
    templateUrl: './currency.component.html',
    styleUrl: './currency.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurrencyComponent {
  @Input() value: number = 0;
  @Input() size: 'normal' | 'large' = 'normal';
  @Input() monthly: boolean = false;
  @Input() emphasis: boolean = false;

  private readonly maximumNumberOfDecimals: number = 2;

  public get whole(): string {
    // If the whole number is "-0" we need to manually return the correct string. JavaScript will automatically render
    // "-0" as "0" when converted to a string (which is always the case for templates). We always can't do a strict
    // check because in JavaScript -0 === 0.
    if (this.value < 0 && this.value > -1) {
      return "-0";
    }

    return Math.trunc(this.value).toString();
  }

  public get decimals(): string {
    const decimals: string = this.value
      .toFixed(this.maximumNumberOfDecimals)
      .slice(-this.maximumNumberOfDecimals);

    if (decimals === "00") {
      return "-";
    }

    return decimals;
  }

  public get formatted(): boolean {
    return this.decimals !== "-";
  }
}
